// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/alternate-aerodrome-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/alternate-aerodrome-types/alternate-aerodrome-types.js';

mount([g0]);
